<template>
  <div>
    <h1 class="flex mb-8 font-bold text-3xl">
      <icon name="store-front" class="w-6 mr-3 fill-gray-700" /> Campanhas
    </h1>

    <div class="flex overflow-x-auto -mx-6">
      <div v-for="campaign in campaigns" :key="campaign.id" class="w-1/4 px-6 mb-2">
        <div class="flex items-center h-full px-3 py-4 shadow-sm rounded-md bg-white">
          <div v-if="campaign.photo_path" class="w-20 h-20 bg-opacity-75">
            <img class="block w-inherit h-inherit max-w-72 max-h-72 m-auto rounded-full mr-2 -my-2" :src="campaign.photo_path" :alt="campaign.name" />
          </div>

          <div class="w-32 ml-5">
            <h4 class="text-lg font-semibold text-gray-700">
              {{ campaign.name }}
            </h4>
          </div>
        </div>
      </div>
    </div>

    <h1 class="flex mt-8 mb-8 font-bold text-3xl">
      <icon name="users" class="w-6 mr-3 fill-gray-700" /> Usuários
    </h1>

    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="text-center px-6 pt-6 pb-4">#</th>
          <th class="px-6 pt-6 pb-4">Nome</th>
        </tr>
        <tr v-for="user in users" :key="user.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <label class="form-label m-auto text-center">
              <input type="checkbox" @change="setReceiver($event, user.id, user.token)" />
            </label>
          </td>
          <td class="border-t">
            <p class="px-6 py-4 flex items-center focus:text-indigo-500">
              <img v-if="user.photo_path" class="block w-5 h-5 rounded-full mr-2 -my-2" :src="user.photo_path" :alt="user.name" />
              {{ user.name }}
            </p>
          </td>
        </tr>
      </table>
    </div>

    <div class="mt-6 flex">
      <button class="btn-indigo ml-auto" @click="send($event)">
        <span>Enviar</span>
      </button>
    </div>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import axios from 'axios'

export default {
  metaInfo: { title: 'Mensagens' },
  components: {
    Icon,
  },
  layout: Layout,
  props: {
    messages:  Array,
    campaigns: Array,
    users:     Array,
  },
  data() {
    return {
      receivers: [],
      tokens: {},
    }
  },
  methods: {
    send(event) {
      if(this.receivers.length == 0)
      {
        return
      }

      const KEY = 'AAAAKfZh0pA:APA91bE5Xr8H1ExAtrmJgDwLlMPEppLB6jBBacNJiCBJK6ps4oJ0awli9cHmeyLZ9VKA1nlM16hkEpZt66YatQex-koBsroUZqG8APVPxz70l7PS4C3bPqLdYtnCKMUd0wJ8ASMvWkGP'

      new Promise((resolve) => {
        this.campaigns.forEach((campaign) => {
          this.receivers.forEach((receiver) => {
            if(!this.tokens[receiver])
            {
              return
            }

            axios.post(
              'https://fcm.googleapis.com/fcm/send',
              {
                to: this.tokens[receiver],
                notification: {
                  title: 'Nova Mensagem!',
                  body: campaign.name,
                },
              },
              {
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `key=${KEY}`,
                },
              },
            )
          })
        })
        console.log(this.messages, this.campaigns, this.receivers, this.tokens)

        resolve()
      }).then(() => {
        event
        this.$inertia.post(this.route('campaigns.send'), {messages: this.messages, receivers: this.receivers})

        event.target.disabled = false
      })
    },
    setReceiver(event, id, token) {
      if(!event.target?.checked)
      {
        this.receivers.splice(this.receivers.indexOf(id), 1)

        if(this.tokens[id])
        {
          delete this.tokens[id]
        }

        return
      }

      this.receivers.push(id)

      if(token !== null)
      {
        this.tokens[id] = token
      }
    },
  },
}
</script>

<style>
.max-w-72
{
  max-width: 18rem;
}
.max-h-72
{
  max-height: 18rem;
}
.w-inherit
{
  width: inherit;
}
.h-inherit
{
  height: inherit;
}
</style>
